import apiEndpoints from '../../apiEndpoints';
import { fetcher } from '../utils/fetchers/fetcher';

export const requestStyles = (
  styleId: string,
  token: string | null,
  forceHeader?: string
): Promise<string> =>
  fetcher<string>(
    `${apiEndpoints.routes.styles}/${styleId}`,
    'GET',
    token,
    forceHeader,
    undefined,
    undefined,
    { Accept: 'text/css' }
  );
